/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, payload) {
  if (method === "post") {
    if (
      (metaData === "getdropdownbarcodedata") |
      (metaData === "getdropdownbillerdata")
    ) {
      return api
        .post(`/org/${metaData}`, payload)
        .then((response) => response.data)
        .catch((error) => Promise.reject(error));
    } else {
      return api
        .post(`/masters/${metaData}`)
        .then((response) => response.data)
        .catch((error) => Promise.reject(error));
    }
  } else {
    return api
      .get(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

export async function loadSalesInvoiceDetails(salesInvoiceList) {
  return await api
    .post(`/org/getsalesreturn`, salesInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadDashboardTransactionsDetails(transactionsList) {
  return await api
    .post(`/org/getdashboardtransaction`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadTotalSalesDetails(transactionsList) {
  return await api
    .post(`/org/gettotalamount`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadTotalPaidDetails(transactionsList) {
  return await api
    .post(`/org/gettotalpaid`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadTotalUnPaidDetails(transactionsList) {
  return await api
    .post(`/org/gettotalunpaid`, transactionsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createSalesInvoiceDetails(salesInvoiceList) {
  return await api
    .post(`/org/createsalesreturn`, salesInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadSearchImeiBarcodeDetails(salesInvoiceList) {
  return await api
    .post(`/org/getsalesbarcode`, salesInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

//party vendor address
export async function loadPartyVendorAddressDetails(addressList) {
  return await api
    .post(`/org/getpartyorvendoraddress`, addressList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createPartyVendorAddressDetails(partyAddress) {
  return await api
    .post(`/org/addpartyorvendorshippingaddress`, partyAddress)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadPartiesCategoryDetails(salesInvoiceList) {
  return await api
    .post(`/org/getpartycategory`, salesInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createPartiesCategoryDetails(salesInvoiceList) {
  return await api
    .post(`/org/createpartycategory`, salesInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function updateSalesInvoiceDetails(salesInvoiceList) {
  return await api
    .put(`/org/updatereturninvoices`, salesInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function deleteSalesInvoiceDetails(salesInvoiceList) {
  return await api
    .post(`/org/deletereturninvoice`, salesInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function loadPartiesTransactionDetails(salesInvoiceList) {
  return await api
    .post(`/org/getpartytransaction`, salesInvoiceList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

const remotes = {
  loadSalesInvoiceDetails,
  loadPartyVendorAddressDetails,
  createPartyVendorAddressDetails,
  loadPartiesTransactionDetails,
  createSalesInvoiceDetails,
  loadRecordsMetaData,
  updateSalesInvoiceDetails,
  deleteSalesInvoiceDetails,
  loadPartiesCategoryDetails,
  createPartiesCategoryDetails,
  loadDashboardTransactionsDetails,
  loadTotalSalesDetails,
  loadTotalPaidDetails,
  loadTotalUnPaidDetails,
  loadSearchImeiBarcodeDetails,
};

export default remotes;
